export default {
  INVITE_USER_GET_REQUEST: "INVITE_USER_GET_REQUEST",
  INVITE_USER_GET_RESPONSE: "INVITE_USER_GET_RESPONSE",
  INVITE_USER_GET_ERROR: "INVITE_USER_GET_ERROR",
  SET_INVITE_TOKEN: "SET_INVITE_TOKEN"
};
